/* eslint-disable max-classes-per-file */
import { Cellstyle, ClickableCell } from "./cell";
import { HotDoc, IRowState } from "./doc";

export interface IExpanderSettings {
    col: number;
    name: string;
}

export class Expander {
    constructor(private readonly rowState: IRowState, readonly expanderSettings) { }
    get expanded(): boolean {
        return this.rowState.expanded || false;
    }
    toggle = (): void => {
        const current = this.rowState.expanded || false;
        this.rowState.expanded = !current;
    };
}

export class HotCellExpander extends ClickableCell {

    constructor(private readonly expander: Expander, flags?: Cellstyle, settings?: any) {
        super(flags, settings);
    }

    onClick = (hotDoc: HotDoc): void => {
        this.expander.toggle();
        hotDoc.rebind();
    };

    protected genHtml(): string {
        return `<button class='btn btn-icon icon-btn accordion-trigger' type='button' ignore-readonly>` +
            `<i class='far fa-chevron-${this.expander.expanded ? "up" : "down"} rotate'></i>` +
            `</button>`;
    }
}
